import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../keycloack/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ROLES } from '../../../utils/constants';

@Component({
  selector: 'app-error-page',
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatCardModule,
  ],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css',
})
export class ErrorPageComponent implements OnInit {
  loggedIn = false;

  constructor(private authService: AuthService, private router: Router) {}

  async ngOnInit() {
    this.loggedIn = await this.authService.isLoggedIn();
  }

  goHome() {
    if (!this.loggedIn) {
      this.router.navigate(['/']);
      return;
    }
    if (this.authService.hasRole(ROLES.superadmin)) {
      this.router.navigate(['superadmin/tenants']);
    } else if (this.authService.hasRole(ROLES.supporto) || this.authService.hasRole(ROLES.asset)) {
      this.router.navigate(['ticketing']);
    } else {
      this.router.navigate(['avvisi']);
    }
  }
}
